export default `
  query GetModel($id: ID!) {
    getModel(id: $id) {
      id
      name
      productType
      productSeries
      spec
      travelLength
      travelHeight
      widthIncAwning
      interiorLength
      interiorHeight
      bodyWidth
      marketingCategory
      priceAU
      priceAUNSW
      priceAUACT
      priceAUVIC
      priceAUQLD
      priceAUSA
      priceAUWA
      priceAUTAS
      priceAUNT
      priceNZ
      weightTowBall
      weightTare
      weightLoading
      features(limit: 1000) {
        items {
          id
          category
          group
          description
          updatedAt
          createdAt
        }
      }
      options(limit: 10000) {
        items {
          option {
            id 
            group 
            category 
            code 
            description
          }
        }
      }
    }
  }
`